import * as React from 'react';

export type Props = {
    width: string;
    height: string;
    style?: React.CSSProperties;
};

export const VolumeUnmute = (props: Props) =>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 18 18"
        { ...props }
    >
        <g>
            { /* tslint:disable */ }
            <path d="M5 7v4h3l4 4V3L8 7H5z"/>
            { /* tslint:enable */ }
        </g>
    </svg>
;



// WEBPACK FOOTER //
// ./src/ui/shapes/VolumeUnmute.tsx